import React from "react";

type NumberedIconProps = {
  sequences: number[];
  starting: boolean;
  underline?: boolean; // lo usiamo come isHeavy
  has_notes?: boolean;
};

export const NumberedIcon: React.FC<NumberedIconProps> = ({
  sequences,
  starting,
  underline,
  has_notes,
}) => {
  const isHeavy = !!underline;

  // colore principale: prima avevi redIcon / greenIcon
  const mainColor = starting ? "#e53935" : "#388e3c";

  const rootClassNames = [
    "poi-pin",
    "poi-pin-number",
    isHeavy ? "poi-pin-heavy" : "",
  ]
    .filter(Boolean)
    .join(" ");

  // come mostrare le sequenze dentro il cerchio
  let label = "";
  if (sequences.length === 1) {
    label = sequences[0].toString();
  } else if (sequences.length <= 3) {
    // es. "1·3·5"
    label = sequences.join("·");
  } else {
    // es. "1…5" se ce ne sono tante
    label = `${sequences[0]}…${sequences[sequences.length - 1]}`;
  }

  return (
    <div className={rootClassNames} style={{ color: mainColor }}>
      <div
        className="poi-pin-circle"
        style={{ backgroundColor: mainColor }}
      >
        {/* buco centrale, come gli altri pin */}
        <div className="poi-pin-hole" />

        {/* pallino note, stesso stile degli altri */}
        {has_notes && <span className="poi-pin-note">!</span>}

        {/* testo con le sequenze */}
        <span className="poi-pin-number-text">{label}</span>
      </div>
    </div>
  );
};
